<e-dialog
  [open]="target() !== null || openWithSourcePicker()"
  (openChange)="onOpenChange($event)"
  [title]="text().title"
  [titleData]="dialogTitleData()"
  size="lg"
  panelClass="moment-link-dialog-pane"
  draggable
>
  <ng-template>
    <div class="moment-link-form">
      @if (error()) {
        <div class="moment-link-error">{{ error() }}</div>
      }
      @if (loading() || sourceLoading()) {
        <div class="moment-link-loading">{{ text().loading }}</div>
      }

      @if (pickerMode()) {
        <!-- Transits-ingang: kies de chart waarvoor het moment bewaard wordt
             (eigen chart vooraan en voorgeselecteerd). -->
        <div class="moment-link-detail-row">
          <span class="moment-link-field-label">{{ text().sourceChartLabel }}</span>
          <ng-select
            class="moment-link-chart moment-link-source-chart"
            appendTo=".moment-link-dialog-pane"
            [items]="sourceChartOptions()"
            bindValue="value"
            bindLabel="label"
            [clearable]="false"
            [placeholder]="text().sourceChartPlaceholder"
            [ngModel]="sourceChartId()"
            (ngModelChange)="onSourceChartChange($event)"
            data-test-id="moment-link-source-chart"
          ></ng-select>
        </div>
        <div class="moment-link-hint">{{ text().sourceChartHint }}</div>
      }

      <!-- Wat wil je loggen? De smaak bepaalt welke velden het formulier toont
           (herinrichting 2026-10-24): gedachte & dagboek, stemming & vitaliteit,
           levensloop, Klassieke I Tjing, gedetailleerd (alles), en met een vaste
           bronchart ook "bestaande chart linken". -->
      <div class="moment-link-modes" role="tablist">
        @for (option of modeOptions(); track option.value) {
          <button type="button" class="moment-link-mode"
                  [class.moment-link-mode--active]="mode() === option.value"
                  (click)="setMode(option.value)"
                  [attr.data-test-id]="'moment-link-mode-' + option.value">
            <i class="{{ option.icon }}" aria-hidden="true"></i> {{ option.label }}
          </button>
        }
      </div>

      @if (mode() === 'iching') {
        <!-- I Tjing-smaak: enkel het tijdstip; de raadpleging zelf gebeurt in de I Tjing-momentdialoog. -->
        <div class="moment-link-date-row">
          <label class="moment-link-field">
            <span class="moment-link-field-label">{{ text().dateLabel }}</span>
            <input type="date" class="moment-link-input" data-test-id="moment-link-iching-date"
                   [ngModel]="dateValue()" (ngModelChange)="onDateChange($event)" />
          </label>
          <label class="moment-link-field">
            <span class="moment-link-field-label">{{ text().ichingTimeLabel }}</span>
            <input type="time" class="moment-link-input" data-test-id="moment-link-iching-time"
                   [ngModel]="timeValue()" (ngModelChange)="onTimeChange($event)" />
          </label>
        </div>
        <div class="moment-link-hint">{{ text().ichingHint }}</div>
        <div class="moment-link-actions">
          <button eBtn type="button" color="primary" icon="scroll-old"
                  [disabled]="ichingStartDisabled()"
                  (click)="startIChing()"
                  data-test-id="moment-link-iching-start">
            {{ text().ichingStart }}
          </button>
        </div>
      } @else if (mode() === 'chart') {
        <ng-select
          class="moment-link-chart"
          appendTo=".moment-link-dialog-pane"
          [items]="chartOptions()"
          bindValue="value"
          bindLabel="label"
          [placeholder]="text().chartPlaceholder"
          [ngModel]="newChartId()"
          (ngModelChange)="newChartId.set($event)"
        ></ng-select>
      } @else {
        <!-- 1. Naam van de entry (default volgt datum, tijd en smaak tot je zelf typt). -->
        <input type="text" class="moment-link-input"
               [placeholder]="text().namePlaceholder"
               [ngModel]="nameValue()" (ngModelChange)="onNameChange($event)"
               data-test-id="moment-link-name" />
      }

      <!-- 2. Vrije tekst: dezelfde composer als de support-reacties (sumiere opmaak +
           afbeeldingen); de toevoegknop staat onderaan het formulier (hideSend).
           Niet in de I Tjing-smaak: een raadpleging heeft eigen notities. -->
      @if (mode() !== 'iching') {
        <support-comment-composer
          [sending]="saving()"
          [placeholder]="composerPlaceholder()"
          [allowEmpty]="true"
          [sendDisabled]="sendDisabled()"
          hideSend
          (send)="onComposerSend($event)"
        ></support-comment-composer>
      }

      @if (dateMode()) {
        <!-- 3. Waar het over gaat, per smaak. -->
        @if (mode() === 'detailed') {
          <div class="moment-link-detail-row">
            <span class="moment-link-field-label">{{ text().categoryLabel }}</span>
            <div class="moment-link-chips">
              @for (category of categories; track category) {
                <button type="button" class="moment-link-chip"
                        [class.moment-link-chip--active]="categoryValue() === category"
                        [title]="detailLabels().categoryHint[category]"
                        (click)="toggleCategory(category)"
                        [attr.data-test-id]="'moment-category-' + category">
                  {{ detailLabels().category[category] }}
                </button>
              }
            </div>
          </div>
          @if (categoryValue(); as chosenCategory) {
            <div class="moment-link-hint" data-test-id="moment-category-hint">{{ detailLabels().categoryHint[chosenCategory] }}</div>
          }
        }

        @if (mindActive()) {
          <!-- Gedachte (spec 2026-10-22-mind-logboek §4; ronde 2 2026-10-24): de transits in je
               openheid staan meteen klaar om aan te tikken (meerdere mag, het centrum volgt de eerste
               keuze); centrum, poort en persoon zitten achter Verfijnen. -->
          <div class="moment-link-mind" data-test-id="moment-mind-block">
            <div class="moment-link-mind__title">
              <i class="fas fa-brain" aria-hidden="true"></i>
              {{ text().mindTitle }}
            </div>
            <div class="moment-link-hint moment-link-mind__intro">{{ text().mindIntro }}</div>

            @if (mindTransitLoading()) {
              <div class="moment-link-loading">{{ text().loading }}</div>
            } @else if (!dateValue()) {
              <div class="moment-link-hint">{{ text().mindTransitNeedsTime }}</div>
            } @else if (mindTransitSuggestions().length === 0) {
              <div class="moment-link-hint" data-test-id="moment-mind-transit-none">{{ text().mindTransitNone }}</div>
            } @else {
              <div class="moment-link-chips" data-test-id="moment-mind-transit-chips">
                @for (suggestion of mindTransitSuggestions(); track suggestion.planetKey + suggestion.gate + suggestion.line) {
                  <button type="button" class="moment-link-chip moment-link-mind__suggestion"
                          [class.moment-link-chip--active]="mindTransitSelected(suggestion)"
                          [disabled]="mindFull() && !mindTransitSelected(suggestion)"
                          [title]="mindSuggestionTitle(suggestion)"
                          (click)="toggleMindTransit(suggestion)"
                          [attr.data-test-id]="'moment-mind-transit-' + suggestion.planetKey + '-' + suggestion.gate">
                    <span class="moment-link-mind__glyph" [style.color]="suggestion.color" aria-hidden="true">{{ suggestion.glyph }}</span>
                    {{ suggestion.gate }}.{{ suggestion.line }}
                    <span class="moment-link-mind__center">{{ text().mindCenterName(suggestion.center) }}</span>
                    @if (suggestion.completesChannel) {
                      <i class="fas fa-link moment-link-mind__link" aria-hidden="true"></i>
                    }
                  </button>
                }
              </div>
            }

            @if (mindConditionerCount() > 0) {
              <div class="moment-link-mind__chosen">
                <span class="moment-link-hint" data-test-id="moment-mind-chosen">{{ text().mindChosen(mindConditionerCount()) }}</span>
                <button type="button" class="moment-link-chip moment-link-mind__insert"
                        [title]="text().mindInsertTextTitle"
                        (click)="insertMindText()"
                        data-test-id="moment-mind-insert-text">
                  <i class="fas fa-text" aria-hidden="true"></i>
                  {{ text().mindInsertText }}
                </button>
              </div>
            }

            <button type="button" class="moment-link-mind__refine"
                    [attr.aria-expanded]="mindRefineOpen()"
                    [title]="text().mindRefineHint"
                    (click)="mindRefineOpen.set(!mindRefineOpen())"
                    data-test-id="moment-mind-refine">
              <i class="fas" [class.fa-chevron-right]="!mindRefineOpen()" [class.fa-chevron-down]="mindRefineOpen()" aria-hidden="true"></i>
              {{ text().mindRefine }}
              @if (!mindRefineOpen() && mindRefineSummary(); as summary) {
                <span class="moment-link-mind__summary">{{ summary }}</span>
              }
            </button>

            @if (mindRefineOpen()) {
              <hd-mind-fields
                [centerOptions]="mindCenterOptions()"
                [gateOptions]="mindGateOptions()"
                [center]="mindCenter()"
                (centerChange)="onMindCenterChange($event)"
                [(gate)]="mindGate"
              ></hd-mind-fields>
              <div class="moment-link-detail-row">
                <span class="moment-link-field-label">{{ text().mindPersonLabel }}</span>
                <ng-select
                  class="moment-link-chart moment-link-mind__person"
                  appendTo=".moment-link-dialog-pane"
                  [items]="mindPersonOptions()"
                  bindValue="value"
                  bindLabel="label"
                  [placeholder]="text().mindPersonPlaceholder"
                  [ngModel]="mindPersonChartId()"
                  (ngModelChange)="onMindPersonChange($event)"
                  data-test-id="moment-mind-person"
                ></ng-select>
              </div>
              @if (mindPersonLoading()) {
                <div class="moment-link-hint">{{ text().loading }}</div>
              } @else if (mindPersonChartId()) {
                @if (mindPersonSuggestions().length === 0) {
                  <div class="moment-link-hint" data-test-id="moment-mind-person-none">{{ text().mindPersonNone }}</div>
                } @else {
                  <div class="moment-link-hint">{{ text().mindPersonGatesLabel }}</div>
                  <div class="moment-link-chips" data-test-id="moment-mind-person-chips">
                    @for (suggestion of mindPersonSuggestions(); track suggestion.planetKey + suggestion.gate + suggestion.line) {
                      <button type="button" class="moment-link-chip moment-link-mind__suggestion"
                              [class.moment-link-chip--active]="mindPersonGates().includes(suggestion.gate)"
                              [title]="suggestion.completesChannel ? text().mindCompletesChannel : ''"
                              (click)="toggleMindPersonGate(suggestion.gate)"
                              [attr.data-test-id]="'moment-mind-person-gate-' + suggestion.gate">
                        <span class="moment-link-mind__glyph" [style.color]="suggestion.color" aria-hidden="true">{{ suggestion.glyph }}</span>
                        {{ suggestion.gate }}.{{ suggestion.line }}
                        @if (suggestion.completesChannel) {
                          <i class="fas fa-link moment-link-mind__link" aria-hidden="true"></i>
                        }
                      </button>
                    }
                  </div>
                }
              }
            }
          </div>
        }

        @if (mode() === 'thought') {
          <!-- Gedachte: emoties, stemming en vitaliteit standaard verborgen; toggles op één regel
               (open = actief, nogmaals klikken sluit de rij en wist de waarde). -->
          <div class="moment-link-extras" data-test-id="moment-thought-extras">
            @for (extra of thoughtExtraOptions(); track extra.key) {
              <button type="button" class="moment-link-chip moment-link-extra"
                      [class.moment-link-chip--active]="extra.open"
                      [attr.aria-pressed]="extra.open"
                      (click)="toggleThoughtExtra(extra.key)"
                      [attr.data-test-id]="'moment-add-' + extra.key">
                <i class="fas" [class.fa-plus]="!extra.open" [class.fa-minus]="extra.open" aria-hidden="true"></i> {{ extra.label }}
              </button>
            }
          </div>
        }

        @if (showVitality()) {
          <div class="moment-link-detail-row">
            <span class="moment-link-field-label">{{ text().vitalityLabel }}</span>
            <div class="moment-link-vitality">
              @for (vitality of vitalityValues; track vitality) {
                <button type="button" class="moment-link-vitality-step"
                        [class.moment-link-vitality-step--active]="vitalityValue() === vitality"
                        [title]="detailLabels().vitality[vitality]"
                        (click)="toggleVitality(vitality)"
                        [attr.data-test-id]="'moment-vitality-' + vitality">
                  <i class="fas fa-{{ vitalityIcons[vitality] }}" aria-hidden="true"></i>
                </button>
              }
            </div>
          </div>
        }

        @if (showMood()) {
          <div class="moment-link-detail-row">
            <span class="moment-link-field-label">{{ text().moodLabel }}</span>
            <hd-dot-picker
              [options]="moodOptions()"
              [value]="moodDotValue()"
              (valueChange)="onMoodPicked($event)"
              testIdPrefix="moment-mood-"
              data-test-id="moment-mood-row"
            ></hd-dot-picker>
          </div>
        }

        @if (showEmotions()) {
          <div class="moment-link-detail-row moment-link-detail-row--wrap">
            <span class="moment-link-field-label">{{ text().emotionsLabel }}</span>
            <div class="moment-link-chips">
              @for (emotion of emotionOptions; track emotion.key) {
                <button type="button" class="moment-link-chip"
                        [class.moment-link-chip--active]="emotionKeys().includes(emotion.key)"
                        [class.moment-link-chip--negative]="emotion.valence === 'negative'"
                        [disabled]="emotionDisabled(emotion.key)"
                        (click)="toggleEmotion(emotion.key)"
                        [attr.data-test-id]="'moment-emotion-' + emotion.key">
                  <i class="fas fa-{{ emotion.icon }}" aria-hidden="true"></i>
                  {{ detailLabels().emotion[emotion.key] }}
                </button>
              }
            </div>
          </div>
        }

        <!-- 4. Gegevens (metadata): datum en tijd, eventueel het einde, kleur en icoon. -->
        <section class="moment-link-meta" data-test-id="moment-link-meta">
          <span class="moment-link-meta__title">{{ text().metaTitle }}</span>
          <div class="moment-link-date-row">
            <label class="moment-link-field">
              <span class="moment-link-field-label">{{ text().dateLabel }}</span>
              <input type="date" class="moment-link-input"
                     [ngModel]="dateValue()" (ngModelChange)="onDateChange($event)" />
            </label>
            <label class="moment-link-field">
              <span class="moment-link-field-label">{{ text().timeLabel }}</span>
              <input type="time" class="moment-link-input"
                     [ngModel]="timeValue()" (ngModelChange)="onTimeChange($event)" />
            </label>
          </div>
          @if (showEndDate()) {
            <!-- Optioneel einde: dan wordt het moment een periode (range) die je met de tijdslider verkent. -->
            <div class="moment-link-date-row">
              <label class="moment-link-field">
                <span class="moment-link-field-label">{{ text().endDateLabel }}</span>
                <input type="date" class="moment-link-input" data-test-id="moment-link-end-date"
                       [ngModel]="dateEndValue()" (ngModelChange)="onEndDateChange($event)" />
              </label>
              <label class="moment-link-field">
                <span class="moment-link-field-label">{{ text().endTimeLabel }}</span>
                <input type="time" class="moment-link-input" data-test-id="moment-link-end-time"
                       [disabled]="!dateEndValue()"
                       [ngModel]="timeEndValue()" (ngModelChange)="onEndTimeChange($event)" />
              </label>
            </div>
          }
          @if (rangeInvalid()) {
            <div class="moment-link-error" data-test-id="moment-link-range-invalid">{{ text().endBeforeStart }}</div>
          } @else if (dateEndValue()) {
            <div class="moment-link-hint">{{ text().rangeHint }}</div>
          } @else if (dateValue() && !timeValue()) {
            <div class="moment-link-hint">{{ text().dayRangeHint }}</div>
          }

          <div class="moment-link-detail-row">
            <span class="moment-link-field-label">{{ text().colorLabel }}</span>
            <hd-color-picker [(value)]="colorValue"></hd-color-picker>
          </div>

          <div class="moment-link-detail-row">
            <span class="moment-link-field-label">{{ text().iconLabel }}</span>
            <button type="button" class="moment-link-chip"
                    [class.moment-link-chip--active]="iconPickerOpen()"
                    (click)="iconPickerOpen.set(!iconPickerOpen())"
                    data-test-id="moment-icon-toggle">
              <i class="fas fa-{{ iconValue() || 'icons' }}" aria-hidden="true"></i>
            </button>
          </div>
          @if (iconPickerOpen()) {
            <!-- Kader zodat de picker zich visueel onderscheidt van de rest van het formulier. -->
            <div class="moment-link-icon-picker" data-test-id="moment-icon-picker-frame">
              <span class="moment-link-icon-picker__title">{{ text().iconLabel }}</span>
              <hd-icon-picker [(value)]="iconValue"></hd-icon-picker>
            </div>
          }
        </section>
      }

      @if (mode() !== 'iching') {
        <!-- 5. Toevoegen: stuurt de composer aan (tekst + afbeeldingen), onderaan het formulier. -->
        <div class="moment-link-actions">
          <button eBtn type="button" color="primary" icon="calendar-star"
                  [disabled]="sendDisabled() || saving()"
                  [loading]="saving()"
                  (click)="submitFromFooter()"
                  data-test-id="moment-link-add">
            {{ text().add }}
          </button>
        </div>
      }
    </div>
  </ng-template>
</e-dialog>
